import { atom } from "recoil";

export const charactersState = atom({
  key: "charactersState",
  default: [],
});
